module.exports = __webpack_public_path__ + "img/banner1.753a9b0.jpg";